import { useState } from 'react';
import PropTypes from 'prop-types';
import { RadioButton } from 'components/UI/RadioButton/RadioButton';
import { DropdownWithMenu } from 'components/UI/DropdownWithMenu/DropdownWithMenu';
import { AccordionCollapsible } from '../DeliveryMethodsAccordion/AccordionCollapsible';
import { PostalAddressForm } from './PostalAddressForm';

export const DeliveryMethodPostalAddress = (props) => {
  const {
    DeliveryMethodId,
    DeliveryMethodDisplayName,
    DeliveryMethodFeeDescription,
    DeliveryMethodDescription,
    selectedDeliveryMethodId,
    handleRadioButtonChange,
    addresses,
    states,
    newAddress,
    selectedAddress,
    setSelectedAddress,
  } = props;

  const [newAddressAdded, setNewAddressAdded] = useState(true);
  const [addNewAddressIsOpen, setAddNewAddressIsOpen] = useState(false);
  const [addressSelection, setAddressSelection] = useState(addresses);
  const [addressChosenValue, setAddressChosenValue] = useState(addresses);
  const isChecked = selectedDeliveryMethodId === DeliveryMethodId;

  const addDeliveryClickHandler = (event) => {
    setNewAddressAdded(false);
    setAddNewAddressIsOpen((prevState) => !prevState);

    event.preventDefault();
  };

  const addressDropdownUpdateHandler = (addressId) => {
    const filteredAddress = addressSelection.filter((item) => item.AddressId === addressId);
    setSelectedAddress(filteredAddress[0]);
  };

  const getAddressDropDownOptions = () =>
    addressSelection.map((address) => ({
      key: address.AddressId,
      name: address.FullAddress,
    }));

  return (
    <>
      <RadioButton
        id={`delivery-option-${DeliveryMethodId}`}
        label={DeliveryMethodDisplayName}
        name="deliveryOptions"
        onChangeHandler={() => handleRadioButtonChange(DeliveryMethodId)}
        smallLabelText={DeliveryMethodFeeDescription}
        value={DeliveryMethodId}
        isChecked={isChecked}
        key={DeliveryMethodId}
        extendClass="panel"
      >
        <AccordionCollapsible id={`collapse-${DeliveryMethodId}`} isActive={isChecked}>
          <div className="collapse-content">
            <div className="delivery-info">
              <small>{DeliveryMethodDescription}</small>
            </div>
            {addressSelection && addressSelection.length > 0 && (
              <div>
                <h3 className="h5">Select the delivery address</h3>

                <div className="form-group">
                  <div className="input-container">
                    <DropdownWithMenu
                      singleColumn
                      dropdownChangeHandler={addressDropdownUpdateHandler}
                      defaultChosenValue={selectedAddress.FullAddress}
                      menuData={getAddressDropDownOptions()}
                      extendClass="select-state-dropdown"
                      updatedChosenValue={addressChosenValue}
                    />
                  </div>
                </div>
                <p>
                  <a
                    href="#!"
                    className={`toggle-collapse link-bold link-add-new-addr ${
                      !addNewAddressIsOpen ? 'collapsed' : ''
                    }`}
                    onClick={addDeliveryClickHandler}
                  >
                    Add a delivery address
                    <span className="icon-plus-minus" />
                  </a>
                </p>
              </div>
            )}

            {addressSelection && !addressSelection.length && (
              <div>
                <h3 className="h5">Add a delivery address</h3>
              </div>
            )}

            <AccordionCollapsible
              isActive={addNewAddressIsOpen || (addressSelection && !addressSelection.length)}
              extendClass="add-new-address-collapse"
            >
              <div
                className={`add-new-addr collapse-content ${
                  !addressSelection.length || (addressSelection.length && !newAddressAdded)
                    ? 'in'
                    : ''
                }`}
              >
                <p>
                  <small>Note: Delivery is only available to addresses within Australia</small>
                </p>

                <PostalAddressForm
                  states={states}
                  selectedStateDesc={selectedAddress?.StateDescription}
                  newAddress={newAddress}
                  shippingMethod={DeliveryMethodId}
                  setSelectedAddress={setSelectedAddress}
                  setAddNewAddressIsOpen={setAddNewAddressIsOpen}
                  setAddressSelection={setAddressSelection}
                  setAddressChosenValue={setAddressChosenValue}
                />
              </div>
            </AccordionCollapsible>
          </div>
        </AccordionCollapsible>
      </RadioButton>
      <hr />
    </>
  );
};

DeliveryMethodPostalAddress.propTypes = {
  DeliveryMethodId: PropTypes.number,
  DeliveryMethodDisplayName: PropTypes.string,
  DeliveryMethodFeeDescription: PropTypes.string,
  DeliveryMethodDescription: PropTypes.string,
  selectedDeliveryMethodId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleRadioButtonChange: PropTypes.func,
  addresses: PropTypes.arrayOf(PropTypes.object),
  selectedAddress: PropTypes.object,
  states: PropTypes.array,
  newAddress: PropTypes.object,
  setSelectedAddress: PropTypes.func,
};
